import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/shared/store'
import { usePartner } from '@/features/auth'
import { AuthLoading } from './AuthLoading'

interface ProtectedRouteProps {
  children: React.ReactNode
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const isAuthInitialized = useAuthStore((s) => s.isAuthInitialized)
  const { partner, isLoading } = usePartner()

  if (!isAuthInitialized || isLoading) {
    return <AuthLoading />
  }

  if (!partner) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}
